import { browser } from '$app/environment'
import { payload } from '$lib/utils/payload/crud'
import { Result } from '$lib/utils/result'
import { unknown } from 'zod'
import type { PageLoad } from './live/$types'
import * as qs from 'qs-esm'
import { env } from '$env/dynamic/public'


const locales = ['cs', 'en']
const defaultLocale = 'cs'

function parseParams({params}: {params: any}) {
      let { locale, slug } = params

      if( ! locales.includes(locale) ) {
            slug = locale
            locale = defaultLocale
      }

      return {
            locale,
            slug: slug ? slug : 'home'
      }
      

}

export const load: PageLoad = async (ctx: any) => {
      const { url, fetch, params } = ctx

      const {locale, slug} = parseParams({params})


      const query = qs.stringify({
            limit: 0,
            populate: {
                  page: {
                        title: true,
                        slug: true,
                  },
            },
            locale: locale,
            depth: 2,
      })

      const { value: config, Err } = await Result(() =>
            payload.find({
                  fetch: fetch,
                  collectionPath: '/globals/config',
                  serverUrl: `${env.PUBLIC_PAYLOAD_URL}`,
                  query: query,
                  origin: env.PUBLIC_SVELTE_URL,

            })
      )

      if( Err ) console.error(Err.message, Err.stack)

      if( Err ) return {
        navigation: null,
        footer: null,
      }


      return {
        locale: locale,
        navigation: config.navigation,
        footer: config.footer,
        seo: {
            title: config.defaultTitle,
            description: config.defaultDescription,
            image: config.seoImage
        },
        socials: config.networks,
        livePreview: url.searchParams.get("live") ?? false,
        rawGlobalData: config
      }
}
